import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ErrorService {
  handleError(errorRes: HttpErrorResponse) {
    let errorMessage = "Ocorreu um erro desconhecido!";

    if (errorRes.error.detail) {
      errorMessage = `
     ${errorRes.error.detail}`;
      return throwError(() => errorMessage);
    }
    return throwError(() => errorMessage);
  }
}
